//引入api接口
import { fun_PostAction } from "@/api/index";
// 导出
export default {
  // 存储数据
  data: () => {
    // 返回
    return {
      // 查询表单对象
      form: {
        title: null, // 项目名称
      },
      // 查询表单配置
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "title",
          placeholder: "请输入"
        },
      ],
      // 列表配置
      tableColumns: [
        {
          label: "公告编号",
          prop: "bianhao",
          width: "250"
        },
        {
          label: "项目名称",
          prop: "title",
          isShow: true,
        },
        {
          label: "发布时间",
          prop: "fbksjs",
          width: "150"
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
      // 加载
      loading:false
    };
  },
   // 模板编译完成
   mounted() {
    // 获取主键
    this.guid = this.$route.query.guid;
    // 执行列表列表获取方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览数据
     * @author 滕威
     */
    fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 执行获取列表接口
        fun_PostAction("/hiLand/announcementBiddingAuctionList", {
          ...this.form,
          ...this.reqPageData
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 将请求到的table数据渲染到table
            this.tableData = data.records;
            // 展示分页总条数
            this.total = data.total;
          } else {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
          // 关闭loading
          this.loading = false;
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
     /**
     * 详情
     */
      fun_LookDetails(e) {
        // 跳转详情，查看明细一览
       const { href } = this.$router.resolve({
        path: "/bidAuctionListingDetails",
        query: {
          guid: e.val.guid,
          type: "details"
        }
      });
      // 打开新窗口
      window.open(href, "_blank");
      },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 下拉框change事件
     * @params e 选择的值
     * @author 滕威
     */
    fun_GetSelectVal(e) {
      console.log(e);
    },
    /**
     * 下拉框clear事件
     * @params field 选择的值
     * @author 滕威
     */
     fun_Clear(field, options) {
      this.form[field] = null;
    },
  }
};
